import ErrorId from '../../api/errorId'
import ErrorMessage from '../../api/errorMessage'
import HttpStatusCodeMessage from '../../api/httpStatusCodeMessage'
import { app } from '@/main'

function ServiceProxy(baseUrl) {
    this.baseUrl = baseUrl
    this.token = ''
}

ServiceProxy.prototype.setToken = function(_token){
	this.token = _token
}

ServiceProxy.prototype.postApi = function(ApiName, body, params){//共用post 
    let token = this.token
    if(!body) body= ''//是否有body
    if(!params) params= ''//是否有參數
    // console.log(JSON.stringify(body))
    // console.log(this.baseUrl)
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest()
        xhr.open('POST', `${this.baseUrl}${ApiName+params}`, true)
        xhr.setRequestHeader('Authorization', token)
        xhr.setRequestHeader('Cache-Control', 'no-cache')//ie同樣api cache問題解法
        xhr.setRequestHeader('If-Modified-Since', '0')//ie同樣api cache問題解法
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.onload = function() {
            try {
                if (xhr.status === 200) {
                    var result = JSON.parse(xhr.responseText)
                    if (result?.result && result?.result != ErrorId.SUCCESS) {
                        serviceProxy.checkResultError(result?.result)
                    }
                    resolve(result)
                } else {
                    if (xhr.status) {
                        serviceProxy.showHttpStatusError(xhr.status)
                    }
                    reject(xhr.responseText)
                }
            } catch (error) {
                console.log(error)
            }
        }
        xhr.onerror = function() {
            reject(xhr.responseText)
        }
        xhr.send(JSON.stringify(body))
    })
}


ServiceProxy.prototype.getApi = function(ApiName, body, params){//共用get 
    let token = this.token
    if(!body) body= ''//是否有body
    if(!params) params= ''//是否有參數
    // console.log(JSON.stringify(body))
    // console.log(params)
    return new Promise((resolve, reject) => {
        
        var xhr = new XMLHttpRequest()
        xhr.open('GET', `${this.baseUrl}${ApiName+params}`, true)
        xhr.setRequestHeader('Authorization', token)
        xhr.setRequestHeader('Cache-Control', 'no-cache')//ie同樣api cache問題解法
        xhr.setRequestHeader('If-Modified-Since', '0')//ie同樣api cache問題解法
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.onload = function() {
            try {
                if (xhr.status === 200) {
                    var result = JSON.parse(xhr.responseText)
                    if (result?.result && result?.result != ErrorId.SUCCESS) {
                        serviceProxy.checkResultError(result?.result)
                    }
                    resolve(result)
                } else {
                    if (xhr.status) {
                        serviceProxy.showHttpStatusError(xhr.status)
                    }
                    reject(xhr.responseText)
                }
            } catch (error) {
                console.log(error)
            }
        }
        xhr.onerror = function() {
            reject(xhr.responseText)
        }
        xhr.send(JSON.stringify(body))

    })
}

ServiceProxy.prototype.deleteApi = function(ApiName, body, params){//共用delete
    let token = this.token
    if(!body) body= ''//是否有body
    if(!params) params= ''//是否有參數
    // console.log(JSON.stringify(body))
    // console.log(params)
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest()
        xhr.open('DELETE', `${this.baseUrl}${ApiName+params}`, true)
        xhr.setRequestHeader('Authorization', token)
        xhr.setRequestHeader('Cache-Control', 'no-cache')//ie同樣api cache問題解法
        xhr.setRequestHeader('If-Modified-Since', '0')//ie同樣api cache問題解法
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.onload = function() {
            try {
                if (xhr.status === 200) {
                    var result = JSON.parse(xhr.responseText)
                    if (result?.result && result?.result != ErrorId.SUCCESS) {
                        serviceProxy.checkResultError(result?.result)
                    }
                    resolve(result)
                } else {
                    if (xhr.status) {
                        serviceProxy.showHttpStatusError(xhr.status)
                    }
                    reject(xhr.responseText)
                }
            } catch (error) {
                console.log(error)
            }
        }
        xhr.onerror = function() {
            reject(xhr.responseText)
        }
        xhr.send(JSON.stringify(body))
    })
}

ServiceProxy.prototype.putApi = function(ApiName, body, params){//共用put
    let token = this.token
    if(!body) body= ''//是否有body
    if(!params) params= ''//是否有參數
    // console.log(JSON.stringify(body))
    // console.log(params)
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest()
        xhr.open('PUT', `${this.baseUrl}${ApiName+params}`, true)
        xhr.setRequestHeader('Authorization', token)
        xhr.setRequestHeader('Cache-Control', 'no-cache')//ie同樣api cache問題解法
        xhr.setRequestHeader('If-Modified-Since', '0')//ie同樣api cache問題解法
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.onload = function() {
            try {
                if (xhr.status === 200) {
                    var result = JSON.parse(xhr.responseText)
                    if (result?.result && result?.result != ErrorId.SUCCESS) {
                        serviceProxy.checkResultError(result?.result)
                    }
                    resolve(result)
                } else {
                    if (xhr.status) {
                        serviceProxy.showHttpStatusError(xhr.status)
                    }
                    reject(xhr.responseText)
                }
            } catch (error) {
                console.log(error)
            }
        }
        xhr.onerror = function() {
            reject(xhr.responseText)
        }
        xhr.send(JSON.stringify(body))
    })
}

ServiceProxy.prototype.uploadFile = function(file, fileinfo){//上傳檔案
    let token = this.token
    return new Promise((resolve, reject) => {
        let body = new FormData()
        body.append('File1', file)
        if(fileinfo !== '' && fileinfo && fileinfo !== undefined){
            body.append('attrs', fileinfo)
        }
        body.append('attrs', '{}')
        var xhr = new XMLHttpRequest()
        xhr.open('POST', `${this.baseUrl}WebAPI/File`, true)
        xhr.setRequestHeader('Authorization', token)
        xhr.setRequestHeader('Cache-Control', 'no-cache')//ie同樣api cache問題解法
        xhr.setRequestHeader('If-Modified-Since', '0')//ie同樣api cache問題解法
        xhr.onload = function() {
            try {
                if (xhr.status === 200) {
                    var result = JSON.parse(xhr.responseText)
                    resolve(result)
                } else {
                    if (xhr.status) {
                        serviceProxy.showHttpStatusError(xhr.status)
                    }
                    reject(xhr.responseText)
                }
            } catch (error) {
                console.log(error)
            }
        }
        xhr.onerror = function() {
            reject(xhr.responseText)
        }
        xhr.send(body)
    })
}


// ServiceProxy.prototype. = function(uuid){//取得上傳檔案
//     // let token = this.token
//     return new Promise((resolve, reject) => {
//         var xhr = new XMLHttpRequest()
//         xhr.open('GET', `${this.baseUrl}cfs/download/${uuid}`, true)
//         // xhr.setRequestHeader('Authorization', token)
//         xhr.setRequestHeader('Cache-Control', 'no-cache')//ie同樣api cache問題解法
//         xhr.setRequestHeader('If-Modified-Since', '0')//ie同樣api cache問題解法
//         xhr.onload = function() {
//             if (xhr.status === 200) {
//                 var result = JSON.parse(xhr.responseText)
//                 resolve(result)
//             } else {
//                 reject(xhr.responseText)
//             }
//         }
//         xhr.onerror = function() {
//             reject(xhr.responseText)
//         }
//     })
// }


ServiceProxy.prototype.getQRcodeURL = function(ApiName, body, params){//共用get 
    let token = this.token
    if(!body) body= ''//是否有body
    if(!params) params= ''//是否有參數
    return new Promise((resolve, reject) => {
        
        var xhr = new XMLHttpRequest()
        xhr.open('GET', `${this.baseUrl}${ApiName+params}`, true)
        xhr.setRequestHeader('Authorization', token)
        xhr.setRequestHeader('Cache-Control', 'no-cache')//ie同樣api cache問題解法
        xhr.setRequestHeader('If-Modified-Since', '0')//ie同樣api cache問題解法
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.responseType = 'blob' //避免解析錯誤，type要設定
        xhr.onload = function() {
            try {
                if (xhr.status === 200) {
                    var reader = new FileReader()
                    reader.onloadend = function(e) {
                        resolve(e.target.result)
                    }
                    reader.readAsDataURL(xhr.response)
                } else {
                    if (xhr.status) {
                        serviceProxy.showHttpStatusError(xhr.status)
                    }
                    reject(xhr.responseText)
                }
            } catch (error) {
                console.log(error)
            }
        }
        xhr.onerror = function() {
            reject(xhr.responseText)
        }
        xhr.send(JSON.stringify(body))

    })
}

// 攔截錯誤訊息，並統一彈窗，可參照axiosBase.js
ServiceProxy.prototype.checkResultError = function(errorId){
    let errorMessage = ErrorMessage.getMessage(errorId)
    console.log('ErrorId : '+ errorId, errorMessage)
    app.messageBox({
        type: 'error',
        title: errorMessage,
        showCancelButton: false
    })
}

ServiceProxy.prototype.showHttpStatusError = function(status){
    let errorMessage = HttpStatusCodeMessage.getMessage(status)
    app.messageBox({
        type: 'error',  
        title: errorMessage,
        showCancelButton: false
    })
}

// var serviceProxy = new ServiceProxy('http://192.168.11.202:8181/')
// var serviceProxy = new ServiceProxy('http://123.205.124.87:8280/') 
// var serviceProxy = new ServiceProxy('http://192.168.11.99:8080/') //ace 

// var serviceProxy = new ServiceProxy('http://192.168.11.201/') 



var serviceProxy = new ServiceProxy(process.env.VUE_APP_API_URL+'/')
// var serviceProxy = new ServiceProxy('http://192.168.11.55/')
export default serviceProxy



// $.ajax({
//     type: 'GET',
//     url: `${this.baseUrl}${ApiName+params}`,
//     dataType: 'json',
//     data: JSON.stringify(body),
//     contentType: 'application/json',
//     beforeSend: function(xhr) {
//         xhr.setRequestHeader('Authorization', token)
//     },
//     success: function (result) {
//         // console.log(result,textStatus,xhr)
//         resolve(result)
//     },
//     error: function (xhr){
//         // console.log(xhr,textStatus,errorThrown)
//         reject(xhr.responseJSON)
//     }
// })